module.exports = __webpack_public_path__ + "img/spinning_watches.a923ba30.gif";